import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';

const FormContext = createContext();

export const FormProvider = ({ children }) => {
  // 1. Initialize State: Check LocalStorage first!
  const [allFormData, setAllFormData] = useState(() => {
    try {
      // Check if we have a saved draft in the browser
      const localData = localStorage.getItem("audit_app_draft");
      return localData ? JSON.parse(localData) : {
        formA: {},
        formB: {},
        formC: {},
        formD: {},
        formE: {},
        formF: {}
      };
    } catch (error) {
      console.error("Error parsing local storage", error);
      return {};
    }
  });

  // 2. Auto-Save: Whenever data changes, save to LocalStorage
  useEffect(() => {
    localStorage.setItem("audit_app_draft", JSON.stringify(allFormData));
  }, [allFormData]);

  // Function to update data for a specific form (memoized)
  const updateForm = useCallback((formName, data) => {
    setAllFormData((prev) => ({
      ...prev,
      [formName]: { ...prev[formName], ...data },
    }));
  }, []);

  // Optional: Function to clear draft (e.g., after final submission)
  const clearDraft = useCallback(() => {
    try { localStorage.removeItem("audit_app_draft"); } catch {}
    setAllFormData({ formA: {}, formB: {}, formC: {}, formD: {}, formE: {}, formF: {} });
  }, []);

  // Stable context value so consumers don't re-run effects due to changing function identities
  const value = useMemo(() => ({ allFormData, updateForm, clearDraft }), [allFormData, updateForm, clearDraft]);

  return (
    <FormContext.Provider value={value}>
      {children}
    </FormContext.Provider>
  );
};

export const useFormContext = () => useContext(FormContext);